import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { ReassuranceSection } from '../components/ReassuranceSection';
import { CtaSection } from '../components/CtaSection';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-[#FAF7F2] selection:bg-[#C9A96E] selection:text-white" data-id="element-70">
      {/* Navigation / Brand Header */}
      <nav className="w-full py-4 px-4 flex justify-center border-b border-[#1C1C1C]/5" data-id="element-71">
        <div className="text-xl font-serif font-bold tracking-tighter text-[#1C1C1C]" data-id="element-72">
          HOGAR <span className="text-[#C9A96E] font-normal italic" data-id="element-73">de</span>{' '}
          REVISTA
        </div>
      </nav>

      <HeroSection data-id="element-74" />
      <FeaturesSection data-id="element-75" />
      <ReassuranceSection data-id="element-76" />
      <CtaSection data-id="element-77" />

      {/* Footer */}
      <footer className="bg-[#1C1C1C] text-[#FAF7F2]/40 py-10 px-4 border-t border-[#FAF7F2]/10" data-id="element-78">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-79">
          <div className="text-sm font-serif" data-id="element-80">
            © 2024 Hogar de Revista. Todos los derechos reservados.
          </div>
          <div className="flex gap-6 text-sm uppercase tracking-widest" data-id="element-81">
            
          </div>
        </div>
      </footer>
    </main>;
}